import React, { useEffect } from 'react';
import { observer } from "mobx-react-lite";

import "../../components/Certificaciones/Certificaciones.css";
import Footer from "../../components/Footer";
import { Card, Image } from 'semantic-ui-react';
import "../../components/Certificaciones/Card_certificaciones.css";
import banner from '../../images/asesorias.jpg';
import { Link } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { getCATCursos } from '../../app/models/CATCursos';
import Perfilpago from './CCTCuenta/Perfilpago';

const loadImage = (imageName: any) => (require(`../../images/${imageName}`).default);
export default observer( function Asesoria() {
  const {userStore: {user, logout, isLoggedIn}} = useStore();
  const {CATCursosStore} = useStore();
  const {loadCATCursosByDir, CATCursosRegistry} = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
        
      loadCATCursosByDir("21");
  
  }    
  }, [CATCursosRegistry.size, loadCATCursosByDir])


  
  return  (
    <div className="contenedor_certificaciones_pagina">
      <img src={banner} alt="imagen" style={{width: "100%"}}></img>
      <div style={{maxWidth: "1324px", margin: "auto"}}>
        <div className="contenedor_descripcion">
              <Perfilpago></Perfilpago>
        </div>
           
      </div>
      <br></br>
      <Footer />
    </div>
  );
})
